import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyNumberArray',
})
export class NumberArrayPipe implements PipeTransform {
    transform(value: number): number[] {
        return Array(value)
            .fill(0)
            .map((_, index) => index);
    }
}
